import React from 'react';
import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { formattedEurToPln, getAmountInPLN } from '../utils/currency';

type ProfitSummaryProps = {
    profits: {
        [currency in SupportedCurrency]: number;
    };
    currencyRecord: CurrencyRecord;
}

export const ProfitSummary = ({ profits, currencyRecord }: ProfitSummaryProps) => {
    const profitEntries = Object.entries(profits).filter(([_, profit]) => profit !== 0) as Array<[SupportedCurrency, number]>;

    const totalInPln = profitEntries.reduce((acc, [currency, profit]) =>
            acc + getAmountInPLN(currencyRecord, profit, currency as SupportedCurrency),
        0);

    return <>{profitEntries.map(([currency, profit], index) => <>
            <span
                key={currency}
                className={profit > 0 ? 'text-success' : 'text-danger'}>{profit.toLocaleString('pl-PL', {
                style: 'currency',
                currency,
            })}</span>{index < profitEntries.length - 1 ? ', ' : ''}
        </>)} <span>({totalInPln.toLocaleString('pl-PL', {
        style: 'currency',
        currency: 'PLN',
    })} po kursie {formattedEurToPln(currencyRecord)})</span></>
};